import { Component, Input, OnInit } from '@angular/core';
import { Audit } from 'app/models/entities/audit';
import { LegfiCurrencyPipe } from 'app/pipes/format/legfi-currency.pipe';
import { LegfiDatePipe } from 'app/pipes/format/legfi-date.pipe';
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { WhereInPipe } from '../../../../../../pipes/collection/where-in.pipe';
import { SumPipe } from '../../../../../../pipes/collection/sum.pipe';
import { AuditDiffFormatterComponent } from '../../formatters/audit-diff-formatter/audit-diff-formatter.component';
import { MatLegacyTableModule } from '@angular/material/legacy-table';

@Component({
    selector: 'app-charge-audit-reporter',
    templateUrl: './charge-audit-reporter.component.html',
    styleUrls: ['./charge-audit-reporter.component.scss'],
    standalone: true,
    imports: [
        LegfiCurrencyPipe,
        LegfiDatePipe,
        NgSwitch,
        MatExpansionModule,
        WhereInPipe,
        SumPipe,
        AuditDiffFormatterComponent,
        MatLegacyTableModule,
        NgSwitchCase,
        NgSwitchDefault,
    ],
})
export class ChargeAuditReporterComponent implements OnInit
{
    @Input() audit: Audit;

    constructor() {
    }

    ngOnInit(): void {
    }

}
